import { ValidationError } from './error.model';

export const PAYMENT_CHECK_INTERVAL = 5000;

export class ResultList<T> {
    cacheUid: string;
    resultList: T[];
    totalCount: number;
}

export class GenericEntity {
    id: number = null;
}

export class DialogData {
    titleLabel: string;
    description: string;
    descriptionLabel: string;
    descriptionHtml: string;
    descriptionValues: { [key: string]: any } = {};
    errors: ValidationError[];
    hasCancelLabel = true;
    cancelLabel = 'BUTTON.CANCEL';
    confirmLabel = 'BUTTON.CONFIRM';
    onConfirm: () => void = null;
    onDismiss: () => void = null;
}

export class CountWrapper<T> {
    results: T[];
    count: number;
}

export class SystemFile {
    token: string;
}

export class BlueMediaResponse {
    redirecturl: string;
}

export enum PaymentStatus {
    SUCCESS = 'SUCCESS',
    PENDING = 'PENDING',
    FAILURE = 'FAILURE'
}

export class PolicyPayment {
    status: PaymentStatus;
    statusDate: string;
}
